<cm-info-section title="Evidence requirements">
    <div *ngFor="let entry of step.content.entries_evidence" class="evidence-requirements-details-container">
        <span class="evidence-requirements-label"> {{ entry.age }} </span>
        <span class="evidence-requirements-value"> {{ entry.requirement }} </span>
    </div>
</cm-info-section>
